<template>
  <div class="nb-alarm-main">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="alarm-tabs" tab-position="left">
      <el-tab-pane label="地磁报警" name="geomagnetism">
        <div class="tab-content">
          <equip-warn ref="geomagnetismWarn"></equip-warn>
        </div>
      </el-tab-pane>
      <el-tab-pane label="地锁报警" name="lock">
        <div class="tab-content">
          <nb-lock-warn ref="lockWarn"></nb-lock-warn>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EquipWarn from './equipWarn.vue';
import NbLockWarn from './nb-lock-warn.vue';

export default {
  name: 'alarm-main',
  components: {
    EquipWarn,
    NbLockWarn,
  },
  data() {
    return {
      activeTab: 'geomagnetism', // 默认显示地磁报警
    };
  },
  mounted() {
    // 根据路由参数设置默认标签页
    this.setActiveTabFromRoute();
  },
  watch: {
    // 监听路由变化，支持浏览器前进后退
    '$route.query.tab'(newVal) {
      this.setActiveTabFromRoute();
    },
  },
  methods: {
    handleTabClick(tab) {
      // 切换标签页时的处理逻辑
      console.log('切换到:', tab.name);
    },
    setActiveTabFromRoute() {
      // 根据路由参数设置默认标签页
      if (this.$route.query.tab === 'lock') {
        this.activeTab = 'lock';
      } else if (this.$route.query.tab === 'geomagnetism') {
        this.activeTab = 'geomagnetism';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nb-alarm-main {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);

  .alarm-tabs {
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: calc(100vh - 100px);
    display: flex;

    ::v-deep .el-tabs__header {
      margin: 0;
      padding: 20px 0;
      border-right: 1px solid #e4e7ed;
      border-bottom: none;
      width: 150px;
      flex-shrink: 0;
    }

    ::v-deep .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
    }

    ::v-deep .el-tabs__nav {
      width: 100%;
    }

    ::v-deep .el-tabs__item {
      width: 100%;
      text-align: left;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }

      &.is-active {
        color: #409EFF;
        background-color: #ecf5ff;
        border-right: 2px solid #409EFF;
      }

      &:hover {
        color: #409EFF;
      }
    }

    ::v-deep .el-tabs__content {
      flex: 1;
      overflow: hidden;
      padding: 0;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
      overflow: auto;
    }

    .tab-content {
      height: 100%;
      padding: 20px;
      padding-bottom: 120px !important; /* 为分页组件留出足够空间 */
      box-sizing: border-box;
      overflow: auto;
      position: relative;
    }
  }
}
</style>

